import styled from 'styled-components';
import { colors } from '../colors';

interface cardFooterProps {
	textWrap?: boolean;
	docFooter?: boolean;
	generateDocumentFooter?: boolean;
	generalDocFooter?: boolean;
}

const CardFooter = styled.div<cardFooterProps>`
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
	${({ textWrap }) =>
		textWrap &&
		`overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
    `}
	${({ docFooter }) =>
		docFooter &&
		`margin: 0 -24px;
        padding: 12px 24px;
        align-items: end;
        justify-content: flex-end;
        display: flex;
        button{
            height: 34px;
            color: ${colors.White};
            font-size: 14px;
            border-radius: 50px;
            font-family: 'RubikMedium'!important;
            & + button{
                margin-left:16px;
                
            }
        }
    `};
	${({ generateDocumentFooter }) =>
		generateDocumentFooter &&
		`margin:0px;
        padding: 14px 24px;
        align-items: end;
        justify-content: flex-end;
        display: flex;
        border: 1px solid ${colors.GreyE1};
        background-color: ${colors.GreyF6};
        box-shadow: 0px -3px 7px rgba(0, 0, 0, 0.03);
        button{
            height: 34px;
            color: ${colors.White};
            font-size: 15px;
            line-height: 18px;
            font-family: 'RubikMedium'!important;
            background: ${colors.BlueDark};
            box-shadow: 0px 3px 4px rgba(0, 0, 0, 0.03);
            border-radius: 18px;
        }
    `};
	${({ generalDocFooter }) =>
		generalDocFooter &&
		`display: flex;
        align-items: center;
        justify-content: space-between;
    `}
`;

export default CardFooter;
